export const showErrorMessage = (error) => {
  if (!error?.message) return;
  return {
    content: error?.message,
    pointing: error?.message ? 'below' : null,
  };
};
